:host {
  --color: #{$colorWhite};
  --background-color: #{$colorGrey90};
  display: inline-flex;

  &[type="success"] {
    --background-color: #{$colorSuccess70};
  }

  &[type="warning"] {
    --color: #{$colorBlack};
    --background-color: #{$colorWarning60};
  }

  &[type="error"] {
    --background-color: #{$colorError60};
  }

  &[type="info"] {
    --background-color: #{$colorPrimary70};
  }

  &[filled][type="error"] {
    --background-color: #{$colorError70};
  }
}

.stzh-badge {
  @include badge;
}
